import { gql } from "@apollo/client";

export const GET_CONSULTA_CIERRE_VENTA_MAESTRO = gql`
query consultaCierreVentaMaestro($mes: Int!, $anio: Int!) {
    consultaCierreVentaMaestro(mes: $mes, anio: $anio) { 
        valorEsperado{
            factura_Codigo
            organizacion_ventas
            fecha_Factura
            fecha_Real
            fecha
            usuario
            zona_ventas_Codigo
            zona_ventas_Nombre
            creado_por
            factura_Referencia_Anul
            factura_Clase
            solicitante_Codigo
            solicitante_Nombre
            solicitante_Ramo
            solicitante_Region
            factura_Cantidad
            material_Codigo
            material_Descripcion
            material_Lote
            oficina_ventas
            remito_Referencia
            remito_Clase
            aPM_Codigo
            aPM_Nombre
            jEFE_Codigo
            jEFE_Nombre
            bUM_Codigo
            bUM_Nombre
            lMTP
            lLTP
            zLTP
            zMTP
            centro
            tipo_Pedido
            material_Tipo
            material_Sub_Tipo
            material_Cantidad
            material_Total_Neto
            factura_Referencia
            factura_IVA
            factura_IIBB_BA
            factura_IIBB_CABA
            factura_IIBBA_CHA
            factura_Total_Neto
            grupo_Imp_Cliente
            grupo_Cliente
            tipo_Cambio
            cod_Cliente_Destinatario
            cliente_Destinatario
            documento_Ventas
        }
    }
}`;